// Contact.js
import React from "react";
import ContactForm from "../components/ContactForm";

const Contact = () => (
  <main style={{ padding: "40px" }}>
    <h2>Contactez-nous</h2>
    <ContactForm />
  </main>
);

export default Contact;
